import {CommandCaller} from '../../lib/commands'
import * as $ from 'jquery'

class EnrolLinkMaker {
	private ajaxPageUrl: string
	private attribute: string

	constructor(attribute: string, ajaxPageUrl: string) {
		this.ajaxPageUrl = ajaxPageUrl
		this.attribute = attribute
	}

	public makeEnrollableLinks() {
		const enrolByNode = (e: Element) => {
			const getIdFromAttribute = () => $(e).attr(this.attribute)
			this.enrolById(parseInt(getIdFromAttribute()))
		}
		this.assignClickHandlerToMatchingNodes(enrolByNode, $( '[' + this.attribute + ']'))
	}

	private assignClickHandlerToMatchingNodes(callback: (e: Element) => void, nodes: JQuery) {
		nodes.each((_, e) => $(e).click((event: Event) => {
			event.preventDefault()
			return callback(e)
		}))
	}

	private enrolById(id: number) {
		const command = new CommandCaller(this.ajaxPageUrl)
		var result = command.runPost('enrol', id) as Promise<string>
		result.then((str: string) => window.location.assign(str))
	}
}

export var makeEnrollableLinks = (attribute: string, url: string) => new EnrolLinkMaker(attribute, url).makeEnrollableLinks()



// WEBPACK FOOTER //
// ./src/compliancetracker/self-assignable goals/public.ts